import React from "react";

const Services = () => {
    return (
        <>
            {/* Services Section */}
            <section id="services" className="services section">
                {/* Section Title */}
                <div className="container section-title" data-aos="fade-up">
                    <h2>Solutions</h2>
                    <p>Case Studies</p>
                </div>{/* End Section Title */}
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={100}>
                            <div className="service-item position-relative">
                                <div className="icon">
                                    <i className="fa-solid fa-microchip" style={{ color: '#df1529' }} />
                                </div>
                                <a href="service-details.html" className="stretched-link">
                                    <h3>Gen AI and Agents</h3>
                                </a>
                                <p>Generative AI and AI Agents for Business.</p>
                            </div>
                        </div>{/* End Service Item */}
                        
                        <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={200}>
                            <div className="service-item position-relative">
                                <div className="icon">
                                    <i className="fa-solid fa-shield-halved" style={{ color: '#ff7300' }} />
                                </div>
                                <a href="index.html" className="stretched-link">
                                    <h3>Fraud Detection</h3>
                                </a>
                                <p>Anamomaly Detection in Financial Transactions.</p>
                            </div>
                        </div>{/* End Service Item */}
                        <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={600}>
                            <div className="service-item position-relative">
                                <div className="icon">
                                    <i className="fa-solid fa-vault" style={{ color: '#03a100' }} />
                                </div>
                                <a href="service-details.html" className="stretched-link">
                                    <h3>Advanced Security</h3>
                                </a>
                                <p>Adaptive and Intelligent Security Controls.</p>
                            </div>
                        </div>{/* End Service Item */}

                        <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={400}>
                            <div className="service-item position-relative">
                                <div className="icon">
                                    <i className="fa-solid fa-eye" style={{ color: '#000000' }} />
                                </div>
                                <a href="index.html" className="stretched-link">
                                    <h3>Observability and Monitoring</h3>
                                </a>
                                <p>Telemetry and Observability for Microservices.</p>
                            </div>
                        </div>{/* End Service Item */}
                        <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={500}>
                            <div className="service-item position-relative">
                                <div className="icon">
                                    <i className="fa-solid fa-cloud" style={{ color: '#008cff' }} />
                                </div>
                                <a href="index.html" className="stretched-link">
                                    <h3>Hybrid Cloud</h3>
                                </a>
                                <p>Why we need hybrid cloud solutions.</p>
                            </div>
                        </div>{/* End Service Item */}
                        <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={600}>
                            <div className="service-item position-relative">
                                <div className="icon">
                                    <i className="fa-brands fa-docker" style={{ color: '#0db7ed' }} />
                                </div>
                                <a href="service-details.html" className="stretched-link">
                                    <h3>Containerization</h3>
                                </a>
                                <p>Application - Deployed at scale.</p>
                            </div>
                        </div>{/* End Service Item */}
                        
                    </div>
                </div>
            </section>
            {/* /Services Section */}

        </>

    );
};

export default Services